import { useContext } from 'react';
import './Login.scss';
import { Card } from 'react-bootstrap';

import Stack9Icon from '../../components/icons/Stack9Icon';
import { AppContext } from '../../contexts/AppContext';

const STACK9_API = process.env.REACT_APP_A9_STACK9_API;

const Login = () => {
  const {
    state: { settings },
  } = useContext(AppContext);
  return (
    <div
      style={{
        backgroundImage: `url(${settings.loginBackgroundImage})`,
      }}
      className="Login d-flex align-items-center justify-content-center flex-column flex-grow-1 m-0 w-100"
    >
      <Card className="login-card">
        <Card.Body className="p-5">
          <img
            className="company-logo"
            src={settings.companyLogo}
            alt={settings.name}
          />
          <h4 className="my-3">{settings.name}</h4>
          <div className="px-4">
            <a
              className="btn btn-block btn-primary"
              href={`${STACK9_API}/auth/login`}
            >
              SIGN IN
            </a>
          </div>
          <hr className="my-4" />
          <Stack9Icon style={{ height: '50px' }} className="mt-2 mb-4" />
          <p className="m-0 letter-spacig-lg">
            POWERED BY APRIL9{' | '}
            <a
              className="text-body"
              href="https://www.stack9.com.au"
              rel="noopener noreferrer"
              target="_blank"
            >
              STACK9.COM.AU
            </a>
          </p>
        </Card.Body>
      </Card>
    </div>
  );
};

export default Login;
